import { useState, useEffect } from "react";
import { Alert,FormRow  } from "../components";
import { useAppContext } from "../context/appContext";
import { useNavigate } from "react-router-dom";

const initialState = {
  name: "",
  email: "",
  password: "",
  location: "",
  isMember: true,
};

const Register = () => {
  const navigate = useNavigate()
  const [values, setValues] = useState(initialState);

  const {user, isLoading, showAlert, displayAlert, registerUser, loginUser} = useAppContext();

  const toggleMember = () => {
    setValues({ ...values, isMember: !values.isMember });
  };

  const handleChange = (e) => {
    setValues({...values, [e.target.name]: e.target.value})
  };
  const onSubmit = (e) => {
    e.preventDefault();
    const {name,email,password,isMember} = values;
    if(!email || !password || (!isMember && !name)){
        displayAlert();
        return;
    }
    const currentUser = {name, email, password}
    if(isMember){
      loginUser(currentUser);
    }else{
      registerUser(currentUser);
    }
    // console.log(values);
  };

  useEffect(()=>{
    if(user){
      setTimeout( () => {
        navigate('/')
      }, 3000)
    }
  }, [user, navigate])

  return (
    <div className="full-page wrapper" onSubmit={onSubmit}>
      <form className="form">
        <h1>YATRA</h1>
        <h3>{values.isMember ? "Login" : "Register"}</h3>
        {showAlert && <Alert />}
        {!values.isMember && (
         <FormRow
         type="text"
         name="name"
         value={values.name}
         handleChange={handleChange}
         labelText="Name"
       />
        )}
         <FormRow
         type="email"
         name="email"
         value={values.email}
         handleChange={handleChange}
         labelText="Email"
       />
       <FormRow
         type="password"
         name="password"
         value={values.password}
         handleChange={handleChange}
         labelText="Password"
       />
        {!values.isMember && (
         <FormRow
         type="text"
         name="location"
         value={values.location}
         handleChange={handleChange}
         labelText="Location"
       />
        )}

        <button type="submit" className="btn" disabled={isLoading}>
          Submit
        </button>

        <p>
          {values.isMember ? "Not a member yet?" : "Already a member?"}
          <button type="button" className="log" onClick={toggleMember}>
            {values.isMember ? "Register" : "Login"}
          </button>
        </p>
      </form>
    </div>
  );
};

export default Register;
